"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SMTGlobalLogisticsInc = void 0;
exports.SMTGlobalLogisticsInc = {
    id: 'smtGlobalLogisticsInc',
    companyName: 'SMT Global Logistics Inc.',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'smtGlobalLogisticsInc',
    },
    isInternal: false,
    isActive: true,
    countries: ['PH'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU01UR2xvYmFsTG9naXN0aWNzSW5jLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2FnZW50cy9kYXRhL1NNVEdsb2JhbExvZ2lzdGljc0luYy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLHFCQUFxQixHQUFVO0lBQ3hDLEVBQUUsRUFBRSx1QkFBdUI7SUFDM0IsV0FBVyxFQUFFLDJCQUEyQjtJQUN4QyxjQUFjLEVBQUUsQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDO0lBQzlCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSx1QkFBdUI7S0FDakM7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=